/* --------------------------------  ONBOARDING  09.04.2018 ------------------------- */
import HELPER from '@/app/utils/HELPER';
import config from '@/app/editor/config';
import { GET } from '@/app/api/index';

(function (jQuery) {
  jQuery.gfOnboarding = function (element, options) {
    const defaults = {};
    const _this = this;
    const $element = jQuery(element);

    // let publicPath = config.domain() + '/editor';

    // if (import.meta.env.VITE_APP_MODE === 'production') {
    //   publicPath = 'https://' + import.meta.env.VITE_APP_CF_URL + '/' + import.meta.env.VITE_APP_E_PATH;
    // }

    const publicPath = import.meta.env.VITE_APP_CF_URL;
    const json = [
      {
        title: 'Start by creating a Row',
        description:
          'Rows keep all your content in a legible, reasonable region in the center of your page. Using rows makes your page more organized.',
        background: '#E8486C',
        images: `${publicPath}/images/Step-01_w82oyh.gif`,
        button: [
          {
            label: 'Skip this step',
            class: 'gfOB_skipStep',
          },
          {
            label: 'Try it now',
            class: 'gfOB_nextStep',
          },
        ],
      },
      {
        title: 'Nesting elements',
        description:
          "Most elements can be nested inside each other. Let's drag and drop Text Block and Image from left Sidebar.",
        background: '#FFC439',
        images: `${publicPath}/images/Step-02_z55o86.gif`,
        button: [
          {
            label: 'Skip this step',
            class: 'gfOB_skipStep',
          },
          {
            label: 'Try it now',
            class: 'gfOB_nextStep',
          },
        ],
      },
      {
        title: 'Insert a pre-designed block',
        description:
          'Introducing Library, where you can find high-converting pre-designed page templates. Save and reuse your own custom designs with ease.',
        background: '#547AFF',
        images: `${publicPath}/images/Step-03_gwq9se.gif`,
        button: [
          {
            label: 'Skip this step',
            class: 'gfOB_skipStep',
          },
          {
            label: 'Try it now',
            class: 'gfOB_nextStep',
          },
        ],
      },
    ];
    let $onboarding;
    let $step_1, $step_2, $step_3;

    let $targetRow;
    let status;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      // GET STATUS LOCAL STORE
      if (localStorage.getItem('gem-onboarding-status')) {
        status = JSON.parse(localStorage.getItem('gem-onboarding-status'));
      } else {
        status = {
          'step-start': false,
          'step-1': false,
          'step-2': false,
          'step-3': false,
          'step-end': false,
          show: true,
        };
      }

      if (!status['step-start'] || !status['step-1'] || !status['step-2'] || !status['step-3'] || !status['step-end']) {
        $onboarding = jQuery('<div id="gfOB"></div>');
        $divContentHidden.append($onboarding);
      }

      const step = '';
      if (!status['step-start']) {
        _this.start();
      } else if (!status['step-1']) {
        _this.step_1();
      } else if (!status['step-2']) {
        _this.step_2();
      } else if (!status['step-3']) {
        _this.step_3();
      } else if (!status['step-end']) {
        _this.end();
      }

      if (status['show'] == false) {
        if ($onboarding != undefined) {
          $onboarding.addClass('hide');
          _this.close();
        }
      }
    };

    this.close = function (step) {
      status['show'] = false;
      localStorage.setItem('gem-onboarding-status', JSON.stringify(status));

      const $templateQuestion = jQuery(
        '<div id="md-questions-onboarding"><svg viewBox="0 0 31.357 31.357" ><path d="M15.255,0c5.424,0,10.764,2.498,10.764,8.473c0,5.51-6.314,7.629-7.67,9.62c-1.018,1.481-0.678,3.562-3.475,3.562c-1.822,0-2.712-1.482-2.712-2.838c0-5.046,7.414-6.188,7.414-10.343c0-2.287-1.522-3.643-4.066-3.643c-5.424,0-3.306,5.592-7.414,5.592c-1.483,0-2.756-0.89-2.756-2.584C5.339,3.683,10.084,0,15.255,0z M15.044,24.406c1.904,0,3.475,1.566,3.475,3.476c0,1.91-1.568,3.476-3.475,3.476c-1.907,0-3.476-1.564-3.476-3.476C11.568,25.973,13.137,24.406,15.044,24.406z"/></svg></div>',
      );
      $divContentHidden.append($templateQuestion);

      $templateQuestion.off().on('click', function (e) {
        e.preventDefault();
        $templateQuestion.remove();
        $onboarding.removeClass('hide');
      });
    };

    this.done = function (step) {
      if (step) {
        status[step] = true;
      }
      if (step == 'step-end') {
        $onboarding.remove();
      }
      localStorage.setItem('gem-onboarding-status', JSON.stringify(status));
    };

    this.getOption = async function (key, callback) {
      const data = {
        shop: shop,
        key: _key,
        value: _value,
      };
      try {
        const res = await GET(api.saveOption().url, data);
        const jsonData = res.data;
        if (jsonData.status != 'success') {
          // Lỗi khi không lưu được option; cài lại mã lỗi
          HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
        }
      } catch (error) {
        // Lỗi khi không lưu được option; cài lại mã lỗi
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }
    };

    this.saveOption = async function (_value) {
      const shop = $gfFrame.data('gfframe').getShopDomain();
      const _key = 'gem-onboarding-status';
      const data = {
        shop: shop,
        key: _key,
        value: _value,
      };
      try {
        const res = await GET(api.saveOption().url, data);
        const jsonData = res.data;
        if (jsonData.status != 'success') {
          // Lỗi khi không lưu được option; cài lại mã lỗi
          HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
        }
      } catch (error) {
        // Lỗi khi không lưu được option; cài lại mã lỗi
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }
    };

    this.calculatorIframe = function ($target) {
      const fST = $gfFrame.contents().scrollTop();
      const fL = $gfFrame.offset().left;
      const fT = $gfFrame.offset().top;

      let _top = $target.offset().top + fT + fST;
      let _left = $target.offset().left + fL;

      _left = _left * window._zoomOut;
      _top = _top * window._zoomOut;

      return {
        top: _top,
        left: _left,
      };
    };

    this.hightlight = function ($target) {
      $target.css({
        transition: 'border 0.3s,box-shadow 0.3s',
        border: '1px solid #F4A259',
        'box-shadow': '0 0 10px #F4A259',
      });

      setTimeout(function () {
        $target.css({
          border: 'none',
          'box-shadow': 'none',
        });
      }, 1000);
    };

    this.hideToolsEditor = function () {
      const $mer = $gryffEditor.children('.gf_row, .module-wrap, .element-wrap');
      if ($mer.data('gfrow') != undefined) {
        $mer.data('gfrow').hideTool();
      } else if ($mer.data('gfmodule') != undefined) {
        $mer.data('gfmodule').hideTool();
      } else if ($mer.data('gfelement') != undefined) {
        $mer.data('gfelement').hideTool();
      }
    };

    this.getTemplateDot = function () {
      let _templateDot = '';
      if (status['step-1']) {
        _templateDot +=
          '<span class="gfOB_dot_1 step_success"><svg viewBox="0 0 512 512"><path d="M468.907,214.604c-11.423,0-20.682,9.26-20.682,20.682v20.831c-0.031,54.338-21.221,105.412-59.666,143.812c-38.417,38.372-89.467,59.5-143.761,59.5c-0.04,0-0.08,0-0.12,0C132.506,459.365,41.3,368.056,41.364,255.883c0.031-54.337,21.221-105.411,59.667-143.813c38.417-38.372,89.468-59.5,143.761-59.5c0.04,0,0.08,0,0.12,0c28.672,0.016,56.49,5.942,82.68,17.611c10.436,4.65,22.659-0.041,27.309-10.474c4.648-10.433-0.04-22.659-10.474-27.309c-31.516-14.043-64.989-21.173-99.492-21.192c-0.052,0-0.092,0-0.144,0c-65.329,0-126.767,25.428-172.993,71.6C25.536,129.014,0.038,190.473,0,255.861c-0.037,65.386,25.389,126.874,71.599,173.136c46.21,46.262,107.668,71.76,173.055,71.798c0.051,0,0.092,0,0.144,0c65.329,0,126.767-25.427,172.993-71.6c46.262-46.209,71.76-107.668,71.798-173.066v-20.842C489.589,223.864,480.33,214.604,468.907,214.604z"/><path d="M505.942,39.803c-8.077-8.076-21.172-8.076-29.249,0L244.794,271.701l-52.609-52.609c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.077-8.077,21.172,0,29.249l67.234,67.234c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.586-2.019,14.625-6.058L505.942,69.052C514.019,60.975,514.019,47.88,505.942,39.803z"/></svg></span>';
      } else {
        _templateDot += '<span class="gfOB_dot_1"></span>';
      }
      if (status['step-2']) {
        _templateDot +=
          '<span class="gfOB_dot_2 step_success"><svg viewBox="0 0 512 512"><path d="M468.907,214.604c-11.423,0-20.682,9.26-20.682,20.682v20.831c-0.031,54.338-21.221,105.412-59.666,143.812c-38.417,38.372-89.467,59.5-143.761,59.5c-0.04,0-0.08,0-0.12,0C132.506,459.365,41.3,368.056,41.364,255.883c0.031-54.337,21.221-105.411,59.667-143.813c38.417-38.372,89.468-59.5,143.761-59.5c0.04,0,0.08,0,0.12,0c28.672,0.016,56.49,5.942,82.68,17.611c10.436,4.65,22.659-0.041,27.309-10.474c4.648-10.433-0.04-22.659-10.474-27.309c-31.516-14.043-64.989-21.173-99.492-21.192c-0.052,0-0.092,0-0.144,0c-65.329,0-126.767,25.428-172.993,71.6C25.536,129.014,0.038,190.473,0,255.861c-0.037,65.386,25.389,126.874,71.599,173.136c46.21,46.262,107.668,71.76,173.055,71.798c0.051,0,0.092,0,0.144,0c65.329,0,126.767-25.427,172.993-71.6c46.262-46.209,71.76-107.668,71.798-173.066v-20.842C489.589,223.864,480.33,214.604,468.907,214.604z"/><path d="M505.942,39.803c-8.077-8.076-21.172-8.076-29.249,0L244.794,271.701l-52.609-52.609c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.077-8.077,21.172,0,29.249l67.234,67.234c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.586-2.019,14.625-6.058L505.942,69.052C514.019,60.975,514.019,47.88,505.942,39.803z"/></svg></span>';
      } else {
        _templateDot += '<span class="gfOB_dot_2"></span>';
      }
      if (status['step-3']) {
        _templateDot +=
          '<span class="gfOB_dot_3 step_success"><svg viewBox="0 0 512 512"><path d="M468.907,214.604c-11.423,0-20.682,9.26-20.682,20.682v20.831c-0.031,54.338-21.221,105.412-59.666,143.812c-38.417,38.372-89.467,59.5-143.761,59.5c-0.04,0-0.08,0-0.12,0C132.506,459.365,41.3,368.056,41.364,255.883c0.031-54.337,21.221-105.411,59.667-143.813c38.417-38.372,89.468-59.5,143.761-59.5c0.04,0,0.08,0,0.12,0c28.672,0.016,56.49,5.942,82.68,17.611c10.436,4.65,22.659-0.041,27.309-10.474c4.648-10.433-0.04-22.659-10.474-27.309c-31.516-14.043-64.989-21.173-99.492-21.192c-0.052,0-0.092,0-0.144,0c-65.329,0-126.767,25.428-172.993,71.6C25.536,129.014,0.038,190.473,0,255.861c-0.037,65.386,25.389,126.874,71.599,173.136c46.21,46.262,107.668,71.76,173.055,71.798c0.051,0,0.092,0,0.144,0c65.329,0,126.767-25.427,172.993-71.6c46.262-46.209,71.76-107.668,71.798-173.066v-20.842C489.589,223.864,480.33,214.604,468.907,214.604z"/><path d="M505.942,39.803c-8.077-8.076-21.172-8.076-29.249,0L244.794,271.701l-52.609-52.609c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.077-8.077,21.172,0,29.249l67.234,67.234c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.586-2.019,14.625-6.058L505.942,69.052C514.019,60.975,514.019,47.88,505.942,39.803z"/></svg></span>';
      } else {
        _templateDot += '<span class="gfOB_dot_3"></span>';
      }
      return _templateDot;
    };

    this.start = function () {
      const jsonStart = {
        title: 'Welcome!',
        description:
          "You've just created your first page. Next we will show you how to design a sample layout with GemPages. Just drag & drop!",
        image: `${publicPath}/images/step00-welcome.png`,
      };
      const $popupStart = jQuery(
        ' <div class="gfOB_background"> <div class="gfOB_start_content"> <svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg> <img src="' +
          jsonStart.image +
          '" alt="#" /> <h3 class="gfOB_title">' +
          jsonStart.title +
          '</h3> <p class="gfOB_desc">' +
          jsonStart.description +
          '</p> <button type="button" class="gfOB_nextStep">Let\'s go</button> </div> </div>',
      );

      $onboarding.html($popupStart);

      // ---- Event
      // close;
      $popupStart
        .find('.gfOB_close')
        .off()
        .on('click', function () {
          $onboarding.addClass('hide');
          _this.close('step-start');
        });

      // next;
      $popupStart
        .find('.gfOB_nextStep')
        .off()
        .on('click', function () {
          $popupStart.remove();
          _this.done('step-start');
          _this.step_1();
        });
    };
    this.end = function () {
      const jsonEnd = {
        title: 'Nice work!',
        description:
          'Time for a cup of coffee. If you have any questions or concerns while using GemPages, feel free to ask us any questions with Live Chat button at bottom right corner.',
        image: `${publicPath}/images/step04-finish.png`,
      };
      const $popupEnd = jQuery(
        '<div class="gfOB_background"> <div class="gfOB_end_content"> <svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg> <img src="' +
          jsonEnd.image +
          '" alt="#" /> <h3 class="gfOB_title">' +
          jsonEnd.title +
          '</h3> <p class="gfOB_desc">' +
          jsonEnd.description +
          '</p><button type="button" class="gfOB_nextStep" style="float: right; margin-top:35px">OK, Done!</button> </div> </div>',
      );

      $onboarding.html($popupEnd);

      // ---- Event
      // close;
      $popupEnd
        .find('.gfOB_close')
        .off()
        .on('click', function () {
          $onboarding.addClass('hide');
          _this.close('step-end');
        });

      //Done
      $popupEnd
        .find('.gfOB_skipStep')
        .off()
        .on('click', function () {
          $onboarding.remove();

          const helpLink = 'https://help.' + config.domain();

          window.open(helpLink, '_blank');
          _this.done('step-end');
        });
      // next;
      $popupEnd
        .find('.gfOB_nextStep')
        .off()
        .on('click', function () {
          $onboarding.remove();
          _this.done('step-end');
        });
    };

    this.step_1 = function () {
      if ($onboarding.find('.gfOB_step_1').length == 0) {
        const i = 0;

        let _templateButton = '';

        _templateButton +=
          '<button type="button" class="' +
          json[i].button[1].class +
          '">' +
          json[i].button[1].label +
          '</button><button type="button" class="' +
          json[i].button[0].class +
          '">' +
          json[i].button[0].label +
          '</button>';

        $step_1 = jQuery(
          '<div class="gfOB_background"> <div class="gfOB_step_content gfOB_step_1"> <svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg> <div class="gfOB_images" style="background:' +
            json[i].background +
            '"> <img src="' +
            json[i].images +
            '" alt="#" /> <div class="gfOB_pre"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M10,14.5c-0.1,0-0.3,0-0.4-0.1l-6-6c-0.2-0.2-0.2-0.5,0-0.7l6-6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7C10.3,14.5,10.1,14.5,10,14.5z" /></svg></div> <div class="gfOB_next"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M10,14.5c-0.1,0-0.3,0-0.4-0.1l-6-6c-0.2-0.2-0.2-0.5,0-0.7l6-6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7C10.3,14.5,10.1,14.5,10,14.5z" /></svg></div> </div> <div class="gfOB_content"> <div class="gfOB_dot"> ' +
            _this.getTemplateDot() +
            ' </div> <h3 class="gfOB_title">' +
            json[i].title +
            '</h3> <p class="gfOB_desc">' +
            json[i].description +
            '</p> ' +
            _templateButton +
            ' </div> </div> </div>',
        );
        $onboarding.append($step_1);

        // Close
        $step_1
          .find('.gfOB_close')
          .off()
          .on('click', function () {
            $onboarding.addClass('hide');
            _this.close('step-1');
          });

        // Next
        $step_1
          .find('.gfOB_next')
          .off()
          .on('click', function () {
            $step_1.find('.gfOB_step_1').addClass('hide_step');
            setTimeout(function () {
              _this.step_2();
              $step_1.addClass('hide');
            }, 200);
          });

        // SKip
        $step_1
          .find('.gfOB_skipStep')
          .off()
          .on('click', function () {
            $step_1.find('.gfOB_step_1').addClass('hide_step');
            setTimeout(function () {
              _this.step_2();
              $step_1.addClass('hide');
            }, 200);
          });

        // try
        $step_1
          .find('.gfOB_nextStep')
          .off()
          .on('click', function () {
            $step_1.find('.gfOB_step_1').addClass('hide_step');
            setTimeout(function () {
              $step_1.addClass('hide');
              _this.step_1_event();
            }, 200);
          });
      } else {
        $step_1.find('.gfOB_step_1').removeClass('hide_step');
        $step_1.removeClass('hide');
        $step_1.find('.gfOB_dot').html(_this.getTemplateDot());
      }
    };

    this.step_1_event = function () {
      _this.hideToolsEditor();
      const jsonStep1 = [
        {
          title: 'Add a row',
          desc: 'Grab and drag this element into the white space on the right.',
        },
        {
          title: 'Settings & Design',
          desc: 'Each element has its own settings and design options on the left sidebar. Click here to split curent row to 2 columns.',
        },
      ];

      const $eventStep1 = jQuery('<div class="gfOB_background step_1_event"></div>');
      $onboarding.append($eventStep1);

      function dragRow() {
        // Clone row;
        $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
        const $snippetRow = $gfLeftSideBar.find('div[data-label="Row"]');
        $snippetRow.clone().prependTo($eventStep1).css({
          top: $snippetRow.offset().top,
          left: $snippetRow.offset().left,
          width: $snippetRow.outerWidth(),
        });

        // Fake box;
        const $snippetEditing = jQuery('<div class="gfOB_box"><span>Drag Element Here</span></div>');

        const position = _this.calculatorIframe($gryffEditor);

        $snippetEditing.prependTo($eventStep1).css({
          top: position.top,
          left: position.left,
          width: $gryffEditor.outerWidth(),
          height: $gryffEditor.outerHeight(),
        });

        // Append tools tips;
        $eventStep1.append(
          '<div class="tools-tips-step-1-1"><span class="arrow-tips"></span><div class="tools-tips-step-body"><svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg><span class="tools-step-title">' +
            jsonStep1[0].title +
            '</span><span class="tools-step-desc">' +
            jsonStep1[0].desc +
            '</span></div></div>',
        );

        // CSS tools tips;
        const leftTips = $snippetRow.outerWidth() / 2 - 5;
        $eventStep1.find('.tools-tips-step-1-1 .arrow-tips').css({
          left: leftTips,
        });

        // On mouse down row fake;
        $eventStep1
          .find('div[data-label="Row"]')
          .off()
          .on('mousedown', function (e) {
            e.preventDefault();
            $eventStep1.addClass('hide');
            $onboarding.addClass('hide');
            setTimeout(function () {
              $snippetRow.trigger('mousedown.drag');
              $gfLeftSideBar.on('mouseup.dragrow', function () {
                // Cancel mouse move
                $onboarding.removeClass('hide');
                $eventStep1.remove();
                _this.step_1();

                $gfLeftSideBar.off('mouseup.dragrow');
                $gryffBody.off('mouseup.dragrow');
                jQuery('body').off('mouseup.dragBrow');
              });
              $gryffBody.on('mouseup.dragrow', function () {
                // On mouse up row fake;
                $eventStep1.html('');
                $eventStep1.removeClass('hide');
                $onboarding.removeClass('hide');

                // Kết thúc bước 1 và chuyển sang bước 2;
                settingsRow();
                $gfLeftSideBar.off('mouseup.dragrow');
                $gryffBody.off('mouseup.dragrow');
                jQuery('body').off('mouseup.dragBrow');
              });
              jQuery('body').on('mouseup.dragBrow', function () {
                // On mouse up row fake;
                $eventStep1.html('');
                $eventStep1.removeClass('hide');
                $onboarding.removeClass('hide');

                // Kết thúc bước 1 và chuyển sang bước 2;
                settingsRow();
                $gfLeftSideBar.off('mouseup.dragrow');
                $gryffBody.off('mouseup.dragrow');
                jQuery('body').off('mouseup.dragBrow');
              });
            }, 100);
          });

        // Quay lai step;
        $eventStep1
          .find('.gfOB_close')
          .off()
          .on('click', function (e) {
            e.preventDefault();
            $eventStep1.remove();
            _this.step_1();
          });
      }

      function settingsRow() {
        // Setting row clones;
        $gfLeftSideBar.find('#md-settings').on('load-settings-success', function () {
          const $settingsRow = $gfLeftSideBar.find('#md-row');

          $settingsRow.clone().prependTo($eventStep1).css({
            top: $settingsRow.offset().top,
            left: $settingsRow.offset().left,
            width: $settingsRow.outerWidth(),
            height: $settingsRow.outerHeight(),
          });
          $eventStep1.find('.optiscroll').removeClass('optiscroll');

          $eventStep1.append(
            '<div class="arrow-down"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d = "M9,2.1v8.2L11.3,8l1.4,1.4L8,14.1L3.3,9.4L4.7,8L7,10.3V2.1H9z"/></svg></div><div class="tools-tips-step-1-2"><span class="arrow-tips"></span><div class="tools-tips-step-body"><svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg><span class="tools-step-title">' +
              jsonStep1[1].title +
              '</span><span class="tools-step-desc">' +
              jsonStep1[1].desc +
              '</span></div></div>',
          );

          const $button66 = $settingsRow.find('button[data-cells="6+6"]');
          const leftTips = $button66.offset().left + $button66.outerWidth() / 2 - 16;
          $eventStep1.find('.tools-tips-step-1-2 .arrow-tips').css({
            left: leftTips,
          });
          $eventStep1.find('.arrow-down').css({
            left: leftTips + 8,
          });

          // Event on mouse down;
          $eventStep1
            .find('button[data-cells="6+6"]')
            .off()
            .on('mouseup', function (e) {
              e.preventDefault();

              $button66.trigger('click');

              $eventStep1.addClass('hide');
              $onboarding.addClass('hide');

              const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
              $targetRow = $gryffBody.find('#' + merId);

              $targetRow.find('.gf_col-md-6').css({
                'min-height': '60px',
              });
              _this.hightlight($targetRow.find('.gf_col-md-6'));
              _this.hideToolsEditor();

              setTimeout(function () {
                // Success step1;
                $eventStep1.remove();
                $onboarding.removeClass('hide');

                $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                _this.done('step-1');
                // Done step 1
                _this.step_2();
              }, 2000);
            });

          // Quay lai step;
          $eventStep1
            .find('.gfOB_close')
            .off()
            .on('click', function (e) {
              e.preventDefault();

              // Quay lại snipets
              $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
              $eventStep1.remove();
              _this.step_1();
            });
        });
      }

      dragRow();
    };

    this.step_2 = function () {
      if ($onboarding.find('.gfOB_step_2').length == 0) {
        const i = 1;
        let _templateButton = '';
        _templateButton +=
          '<button type="button" class="' +
          json[i].button[1].class +
          '">' +
          json[i].button[1].label +
          '</button><button type="button" class="' +
          json[i].button[0].class +
          '">' +
          json[i].button[0].label +
          '</button>';

        $step_2 = jQuery(
          '<div class="gfOB_background"> <div class="gfOB_step_content gfOB_step_2"> <svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg> <div class="gfOB_images" style="background:' +
            json[i].background +
            '"> <img src="' +
            json[i].images +
            '" alt="#" /> <div class="gfOB_pre"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M10,14.5c-0.1,0-0.3,0-0.4-0.1l-6-6c-0.2-0.2-0.2-0.5,0-0.7l6-6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7C10.3,14.5,10.1,14.5,10,14.5z" /></svg></div> <div class="gfOB_next"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M10,14.5c-0.1,0-0.3,0-0.4-0.1l-6-6c-0.2-0.2-0.2-0.5,0-0.7l6-6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7C10.3,14.5,10.1,14.5,10,14.5z" /></svg></div> </div> <div class="gfOB_content"> <div class="gfOB_dot"> ' +
            _this.getTemplateDot() +
            ' </div> <h3 class="gfOB_title">' +
            json[i].title +
            '</h3> <p class="gfOB_desc">' +
            json[i].description +
            '</p> ' +
            _templateButton +
            ' </div> </div> </div>',
        );
        $onboarding.append($step_2);

        //Close
        $step_2
          .find('.gfOB_close')
          .off()
          .on('click', function () {
            $onboarding.addClass('hide');
            _this.close('step-2');
          });

        // Pre
        $step_2
          .find('.gfOB_pre')
          .off()
          .on('click', function () {
            $step_2.find('.gfOB_step_2').addClass('hide_step');
            setTimeout(function () {
              _this.step_1();
              $step_2.addClass('hide');
            }, 200);
          });
        //Next
        $step_2
          .find('.gfOB_next')
          .off()
          .on('click', function () {
            $step_2.find('.gfOB_step_2').addClass('hide_step');
            setTimeout(function () {
              _this.step_3();
              $step_2.addClass('hide');
            }, 200);
          });
        // Next
        $step_2
          .find('.gfOB_skipStep')
          .off()
          .on('click', function () {
            $step_2.find('.gfOB_step_2').addClass('hide_step');
            setTimeout(function () {
              _this.step_3();
              $step_2.addClass('hide');
            }, 200);
          });

        // try
        $step_2
          .find('.gfOB_nextStep')
          .off()
          .on('click', function () {
            $step_2.find('.gfOB_step_2').addClass('hide_step');
            setTimeout(function () {
              $step_2.addClass('hide');
              _this.step_2_event();
            }, 200);
          });
      } else {
        $step_2.find('.gfOB_step_2').removeClass('hide_step');
        $step_2.removeClass('hide');
        $step_2.find('.gfOB_dot').html(_this.getTemplateDot());
      }
    };

    this.step_2_event = function () {
      _this.hideToolsEditor();

      if (!$targetRow) {
        let html =
          '&lt;div data-label="Row" data-key="row" id="r-1523507986245" class="gf_row" data-icon="gpicon-row" data-id="1523507986245" data-extraclass=""&gt;&lt;div class="gf_column gf_col-md-6" id="c-1523507986179" data-id="1523507986179" style="min-height: auto;"&gt;&lt;/div&gt;&lt;div class="gf_column gf_col-md-6" id="c-1523507987033" data-id="1523507987033"&gt;&lt;/div&gt;&lt;/div&gt;';
        let bkHtml =
          '&lt;div id="row-1523507986245"&gt;&lt;div class="snippet-icon"&gt;&lt;i class="gpicon-row"&gt;&lt;/i&gt;&lt;/div&gt;&lt;span class="snippet-label"&gt;Row&lt;/span&gt;&lt;span class="snippet-desc"&gt;Place content elements inside the row&lt;/span&gt; &lt;scri-pt class="template" type="text/plain" id="1523507958263"&gt; &lt;div class="gf_col-md-12 gf_column"&gt;&lt;/div&gt; &lt;/scri-pt&gt; &lt;style rel="stylesheet" class="style" type="text/css"&gt;#r-1523507986245{}&lt;/style&gt;&lt;/div&gt;&lt;div id="column-1523507986179"&gt;&lt;style rel="stylesheet" class="style" type="text/css"&gt;#c-1523507986179 {}&lt;/style&gt;&lt;/div&gt;&lt;div id="column-1523507987033"&gt;&lt;style rel="stylesheet" class="style" type="text/css"&gt;#c-1523507987033 {}&lt;/style&gt;&lt;/div&gt;';

        html = html.replace(/scri-pt/g, 'script');
        html = HELPER.simpleHTMLEntities(html);
        bkHtml = bkHtml.replace(/scri-pt/g, 'script');
        bkHtml = HELPER.simpleHTMLEntities(bkHtml);
        $gryffEditor.data('gryffeditor').addEditorContent(html, bkHtml, undefined, function () {});
        $targetRow = $gryffEditor.find('div[data-label="Row"]').eq(0);

        $gfFrame.contents().scrollTop(0);
      }
      const jsonStep2 = [
        {
          title: 'Add an image',
          desc: "Let's repeat the previous step width this element.",
        },
        {
          title: 'Add a text block',
          desc: 'Drag and drop this element to the droppable area on the right',
        },
      ];

      const $eventStep2 = jQuery('<div class="gfOB_background step_2_event"></div>');
      $onboarding.append($eventStep2);

      function dragImage() {
        // Clone row;
        $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
        const $snippetImage = $gfLeftSideBar.find('div[data-label="Image"]');
        $snippetImage.clone().prependTo($eventStep2).css({
          top: $snippetImage.offset().top,
          left: $snippetImage.offset().left,
          width: $snippetImage.outerWidth(),
        });

        // fake row col-6;

        // targetRow cache từ bước 1;
        const $col6_first = $targetRow.find('.gf_col-md-6').eq(0);

        const position = _this.calculatorIframe($col6_first);

        $col6_first.clone().prependTo($eventStep2).css({
          top: position.top,
          left: position.left,
          width: $col6_first.outerWidth(),
          height: $col6_first.outerHeight(),
        });

        // Append tools tips;
        $eventStep2.append(
          '<div class="tools-tips-step-2-1"><span class="arrow-tips"></span><div class="tools-tips-step-body"><svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg><span class="tools-step-title">' +
            jsonStep2[0].title +
            '</span><span class="tools-step-desc">' +
            jsonStep2[0].desc +
            '</span></div></div>',
        );

        // CSS tools tips;
        const leftTips = $snippetImage.outerWidth() / 2 - 5 + $snippetImage.outerWidth();
        $eventStep2.find('.tools-tips-step-2-1 .arrow-tips').css({
          left: leftTips,
        });

        $eventStep2.find('.tools-tips-step-2-1').css({
          left: $snippetImage.offset().left - $snippetImage.outerWidth(),
          top: $snippetImage.offset().top + $snippetImage.outerHeight() + 5,
        });

        // On mouse down image fake;
        $eventStep2
          .find('div[data-label="Image"]')
          .off()
          .on('mousedown', function (e) {
            e.preventDefault();

            $eventStep2.addClass('hide');
            $onboarding.addClass('hide');

            setTimeout(function () {
              $snippetImage.trigger('mousedown.drag');

              $gfLeftSideBar.on('mouseup.dragImage', function () {
                // Cancel mouse move
                $onboarding.removeClass('hide');
                $eventStep2.remove();
                _this.step_2();

                $gfLeftSideBar.off('mouseup.dragImage');
                $gryffBody.off('mouseup.dragImage');
                jQuery('body').off('mouseup.dragImage');
              });
              $gryffBody.on('mouseup.dragImage', function () {
                // On mouse up row fake;
                _this.hightlight($col6_first);
                _this.hideToolsEditor();

                setTimeout(function () {
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  // On mouse up row fake;
                  $eventStep2.removeClass('hide');
                  $onboarding.removeClass('hide');
                  $eventStep2.html('');
                }, 1500);

                setTimeout(function () {
                  dragTextBlock();
                }, 1600);

                $gfLeftSideBar.off('mouseup.dragImage');
                $gryffBody.off('mouseup.dragImage');
                jQuery('body').off('mouseup.dragImage');
              });
              jQuery('body').on('mouseup.dragImage', function () {
                // On mouse up row fake;
                _this.hightlight($col6_first);
                _this.hideToolsEditor();

                setTimeout(function () {
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  // On mouse up row fake;
                  $eventStep2.removeClass('hide');
                  $onboarding.removeClass('hide');
                  $eventStep2.html('');
                }, 1500);

                setTimeout(function () {
                  dragTextBlock();
                }, 1600);

                $gfLeftSideBar.off('mouseup.dragImage');
                $gryffBody.off('mouseup.dragImage');
                jQuery('body').off('mouseup.dragImage');
              });
            }, 100);
          });

        // Quay lai step;
        $eventStep2
          .find('.gfOB_close')
          .off()
          .on('click', function (e) {
            e.preventDefault();
            $eventStep2.remove();
            _this.step_2();
          });
      }

      function dragTextBlock() {
        // Clone row;
        $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
        const $snippetTextBlock = $gfLeftSideBar.find('div[data-label="Text Block"]');
        $snippetTextBlock.clone().prependTo($eventStep2).css({
          top: $snippetTextBlock.offset().top,
          left: $snippetTextBlock.offset().left,
          width: $snippetTextBlock.outerWidth(),
        });

        // fake row col-6;

        // targetRow cache từ bước 1;
        const $col6_last = $targetRow.find('.gf_col-md-6').eq(1);

        const position = _this.calculatorIframe($col6_last);

        $col6_last.clone().prependTo($eventStep2).css({
          top: position.top,
          left: position.left,
          width: $col6_last.outerWidth(),
          height: $col6_last.outerHeight(),
        });

        // Append tools tips;
        $eventStep2.append(
          '<div class="tools-tips-step-2-2"><span class="arrow-tips"></span><div class="tools-tips-step-body"><svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg><span class="tools-step-title">' +
            jsonStep2[1].title +
            '</span><span class="tools-step-desc">' +
            jsonStep2[1].desc +
            '</span></div></div>',
        );

        // CSS tools tips;
        const leftTips = $snippetTextBlock.outerWidth() / 2 - 5;
        $eventStep2.find('.tools-tips-step-2-2 .arrow-tips').css({
          left: leftTips,
        });

        $eventStep2.find('.tools-tips-step-2-2').css({
          left: $snippetTextBlock.offset().left,
          top: $snippetTextBlock.offset().top + $snippetTextBlock.outerHeight() + 5,
        });

        // On mouse down image fake;
        $eventStep2
          .find('div[data-label="Text Block"]')
          .off()
          .on('mousedown', function (e) {
            e.preventDefault();

            $eventStep2.addClass('hide');
            $onboarding.addClass('hide');

            _this.hideToolsEditor();

            setTimeout(function () {
              $snippetTextBlock.trigger('mousedown.drag');

              $gfLeftSideBar.on('mouseup.dragTextBlock', function () {
                // Cancel mouse move
                $onboarding.removeClass('hide');
                $eventStep2.remove();
                _this.step_2();

                $gfLeftSideBar.off('mouseup.dragTextBlock');
                $gryffBody.off('mouseup.dragTextBlock');
                jQuery('body').off('mouseup.dragTextBlock');
              });
              $gryffBody.on('mouseup.dragTextBlock', function () {
                // On mouse up row fake;
                _this.hightlight($col6_last);
                _this.hideToolsEditor();

                setTimeout(function () {
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  // On mouse up row fake;
                  $eventStep2.remove();
                  $onboarding.removeClass('hide');
                }, 2500);

                setTimeout(function () {
                  _this.done('step-2');
                  _this.step_3();
                }, 2600);

                $gfLeftSideBar.off('mouseup.dragTextBlock');
                $gryffBody.off('mouseup.dragTextBlock');
                jQuery('body').off('mouseup.dragTextBlock');
              });
              jQuery('body').on('mouseup.dragTextBlock', function () {
                // On mouse up row fake;
                _this.hightlight($col6_last);
                _this.hideToolsEditor();

                setTimeout(function () {
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  // On mouse up row fake;
                  $eventStep2.remove();
                  $onboarding.removeClass('hide');
                }, 2500);

                setTimeout(function () {
                  _this.done('step-2');
                  _this.step_3();
                }, 2600);

                $gfLeftSideBar.off('mouseup.dragTextBlock');
                $gryffBody.off('mouseup.dragTextBlock');
                jQuery('body').off('mouseup.dragTextBlock');
              });
            }, 100);
          });

        // Quay lai step;
        $eventStep2
          .find('.gfOB_close')
          .off()
          .on('click', function (e) {
            e.preventDefault();
            $eventStep2.remove();
            _this.step_2();
          });
      }

      dragImage();
    };

    this.step_3 = function () {
      if ($onboarding.find('.gfOB_step_3').length == 0) {
        const i = 2;
        let _templateButton = '';
        _templateButton +=
          '<button type="button" class="' +
          json[i].button[1].class +
          '">' +
          json[i].button[1].label +
          '</button><button type="button" class="' +
          json[i].button[0].class +
          '">' +
          json[i].button[0].label +
          '</button>';

        $step_3 = jQuery(
          '<div class="gfOB_background"> <div class="gfOB_step_content gfOB_step_3"> <svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg> <div class="gfOB_images" style="background:' +
            json[i].background +
            '"> <img src="' +
            json[i].images +
            '" alt="#" /> <div class="gfOB_pre"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M10,14.5c-0.1,0-0.3,0-0.4-0.1l-6-6c-0.2-0.2-0.2-0.5,0-0.7l6-6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7C10.3,14.5,10.1,14.5,10,14.5z" /></svg></div> <div class="gfOB_next"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M10,14.5c-0.1,0-0.3,0-0.4-0.1l-6-6c-0.2-0.2-0.2-0.5,0-0.7l6-6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L4.7,8l5.6,5.6c0.2,0.2,0.2,0.5,0,0.7C10.3,14.5,10.1,14.5,10,14.5z" /></svg></div> </div> <div class="gfOB_content"> <div class="gfOB_dot"> ' +
            _this.getTemplateDot() +
            ' </div> <h3 class="gfOB_title">' +
            json[i].title +
            '</h3> <p class="gfOB_desc">' +
            json[i].description +
            '</p> ' +
            _templateButton +
            ' </div> </div> </div>',
        );
        $onboarding.append($step_3);

        //Close
        $step_3
          .find('.gfOB_close')
          .off()
          .on('click', function () {
            $onboarding.addClass('hide');
            _this.close('step-3');
          });

        // Pre
        $step_3
          .find('.gfOB_pre')
          .off()
          .on('click', function () {
            $step_3.find('.gfOB_step_3').addClass('hide_step');
            setTimeout(function () {
              _this.step_2();
              $step_3.addClass('hide');
            }, 200);
          });
        // Next off
        $step_3
          .find('.gfOB_skipStep')
          .off()
          .on('click', function () {
            $step_3.find('.gfOB_step_3').addClass('hide_step');
            setTimeout(function () {
              // _this.step_3();
              $step_3.addClass('hide');
            }, 200);
          });

        // try
        $step_3
          .find('.gfOB_nextStep')
          .off()
          .on('click', function () {
            $step_3.find('.gfOB_step_3').addClass('hide_step');
            setTimeout(function () {
              $step_3.addClass('hide');
              _this.step_3_event();
            }, 200);
          });
      } else {
        $step_3.find('.gfOB_step_3').removeClass('hide_step');
        $step_3.removeClass('hide');
        $step_3.find('.gfOB_dot').html(_this.getTemplateDot());
      }
    };

    this.step_3_event = function () {
      const jsonStep3 = [
        {
          title: 'Open Library',
          desc: 'Click button above to open Gempages Library.',
        },
        {
          title: 'Insert a block',
          desc: "Click 'Insert' to add this pre-designed block to bottom of the page.",
        },
      ];

      const $eventStep3 = jQuery('<div class="gfOB_background step_3_event"></div>');
      $onboarding.append($eventStep3);

      function clickLibrary() {
        // Clone row;
        const $snippetLibrary = $divTopBar.find('#gf-library');
        $snippetLibrary.clone().prependTo($eventStep3).css({
          top: $snippetLibrary.offset().top,
          left: $snippetLibrary.offset().left,
          width: $snippetLibrary.outerWidth(),
          height: $snippetLibrary.outerHeight(),
        });

        // fake row col-6;

        // Append tools tips;
        $eventStep3.append(
          '<div class="tools-tips-step-3-1"><span class="arrow-tips"></span><div class="tools-tips-step-body"><svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg><span class="tools-step-title">' +
            jsonStep3[0].title +
            '</span><span class="tools-step-desc">' +
            jsonStep3[0].desc +
            '</span></div></div>',
        );

        // CSS tools tips;
        const leftTips = $snippetLibrary.outerWidth() / 2 - 5;
        $eventStep3.find('.tools-tips-step-3-1 .arrow-tips').css({
          left: leftTips,
        });

        $eventStep3.find('.tools-tips-step-3-1').css({
          left: $snippetLibrary.offset().left,
          top: $snippetLibrary.offset().top + $snippetLibrary.outerHeight() + 6,
        });

        // TODO: Wating for revamp onboarding
        // On mouse down image fake;
        $eventStep3
          .find('#gf-library')
          .off()
          .on('mousedown', function (e) {
            e.preventDefault();

            $eventStep3.addClass('hide');
            $eventStep3.html('');

            app.$store.commit(`library/${mutations.TOGGLE}`, true);
            app.$store.commit(`library/${mutations.CHANGE_LAYOUT}`, 'default');
            app.$store.commit(`library/${mutations.CHANGE_TAB}`, 'blocks');

            let checkLibraryRender;
            checkLibraryRender = setInterval(function () {
              if (jQuery('.library-blocks').length > 0) {
                clearInterval(checkLibraryRender);
                setTimeout(function () {
                  $eventStep3.removeClass('hide');
                  clickInsert();
                }, 1500);
              }
            }, 16);
          });

        // Quay lai step;
        $eventStep3
          .find('.gfOB_close')
          .off()
          .on('click', function (e) {
            e.preventDefault();
            $eventStep3.remove();
            _this.step_3();
          });
      }

      function clickInsert() {
        const $blockLast = jQuery('.library-blocks').find('.masonry-item .block-item').eq(1);

        const $buttonInsert = $blockLast.find('.gf-lib-item__btn-insert');

        //fake block;
        const $blockFake = jQuery('<div class="gfOB_background_step_3"></div>');
        $eventStep3.append($blockFake);
        $blockFake.css({
          top: $blockLast.offset().top,
          left: $blockLast.offset().left,
          width: $blockLast.outerWidth(),
          height: $blockLast.outerHeight(),
          background: 'rgba(0,0,0,0.6)',
          position: 'absolute',
          'z-index': 10,
        });

        $buttonInsert.clone().prependTo($eventStep3).css({
          top: $buttonInsert.offset().top,
          left: $buttonInsert.offset().left,
          width: $buttonInsert.outerWidth(),
          height: $buttonInsert.outerHeight(),
        });

        $eventStep3.append(
          '<div class="tools-tips-step-3-1"><span class="arrow-tips"></span><div class="tools-tips-step-body"><svg class="gfOB_close" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg><span class="tools-step-title">' +
            jsonStep3[1].title +
            '</span><span class="tools-step-desc">' +
            jsonStep3[1].desc +
            '</span></div></div>',
        );

        // CSS tools tips;
        const leftTips = $buttonInsert.outerWidth() / 2 - 5;
        $eventStep3.find('.tools-tips-step-3-1 .arrow-tips').css({
          left: leftTips,
        });

        $eventStep3.find('.tools-tips-step-3-1').css({
          left: $buttonInsert.offset().left,
          top: $buttonInsert.offset().top + $buttonInsert.outerHeight() + 15,
        });

        $eventStep3
          .find('.gf-lib-item__btn-insert')
          .off()
          .on('click', function (e) {
            e.preventDefault();
            $eventStep3.addClass('hide');
            $buttonInsert.trigger('click');
            setTimeout(function () {
              $step_3.find('.gfOB_dot').html(_this.getTemplateDot());
              $eventStep3.remove();
              _this.end();
              _this.done('step-3');
            }, 3000);
          });
      }

      clickLibrary();
    };

    this.init();
  };
  jQuery.fn.gfOnboarding = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfonboarding')) {
        const plugin = new jQuery.gfOnboarding(this, options);
        jQuery(this).data('gfonboarding', plugin);
      }
    });
  };
})(jQuery);
